import { render } from "./MtnNigeriaPrizes.vue?vue&type=template&id=6f5d42e9&scoped=true"
import script from "./MtnNigeriaPrizes.vue?vue&type=script&lang=js"
export * from "./MtnNigeriaPrizes.vue?vue&type=script&lang=js"

import "./MtnNigeriaPrizes.vue?vue&type=style&index=0&id=6f5d42e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5d42e9"]])

export default __exports__